import { DaysNumberInAWeek, DayNumberMapping, StoreOpenTimeAttrDayMapping } from "@/data/constants/clickAndCollect";
import { useLocalization } from "@/data/Localization";
import { displayStoreWithStock } from "@/data/types/Store";
import { findStoreAttributeValueByName, getStoreURL } from "@/data/utils/StoreStock";
import { Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Linkable } from "@/components/blocks/Linkable";
import { moreInfoBtnSx } from "../styles/storeDetailsPopup";

type Props = {
    popupStoreAndFeature:displayStoreWithStock, 
    setPopupStoreAndFeature:(store:displayStoreWithStock|undefined)=>void
}

export const StoreDetailsPopup: FC<Props> = ({popupStoreAndFeature, setPopupStoreAndFeature}) => {
    const {store , feature:feature} = popupStoreAndFeature;
    const storeStockNLS = useLocalization('StoreStock');
    const ClickAndCollectNLS = useLocalization("ClickAndCollect");
    const storeLocatorRoute = useLocalization('Routes').StoreLocator.route.t();
    const [storepickallowed, setStorepickallowed] = useState(false);
    const [storeTimings, setStoreTimings] = useState("");
    const [storeURL, setStoreURL] = useState(storeLocatorRoute);
    const handleClose = (event:{}, reason:string) => {
        if(reason==="backdropClick")setPopupStoreAndFeature(undefined);
      };
    useEffect(()=>{
        const temptorepickallowed = findStoreAttributeValueByName(store.attributes, "storepickallowed");
        setStorepickallowed(temptorepickallowed==="1");
        setStoreURL(getStoreURL(store, storeLocatorRoute))
    },[store])

    useEffect(()=>{
        let tempStoreTimings = "Vandaag geopend van ";
        if(feature.hasSpecialTimes){
            tempStoreTimings+=feature.storeTimingsSpecial.replace("-","tot");
        }else{
            tempStoreTimings+=feature.storeTimings.replace("-","tot");
        }
        setStoreTimings(tempStoreTimings);
    },[feature])
    return (
        <Box>
            <Dialog onClose={(event, reason) => handleClose(event, reason)} open={store ? true : false}>
                <DialogTitle>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" columnGap={2}>
                        <Typography variant="h5">{ClickAndCollectNLS.StoreToyStoreKeyword.t()} {store.storeName}</Typography>
                        <CloseIcon onClick={() => setPopupStoreAndFeature(undefined)} sx={{ cursor: 'pointer' }} />
                    </Stack>
                </DialogTitle>
                <DialogContent sx={{ minWidth: '350px', padding: '20px 36px' }}>
                    <Typography variant="h5" pb={2}>{storeStockNLS.OpeningHours.t()}</Typography>
                    <Stack rowGap={1}>
                        {DaysNumberInAWeek.map((day: number) =>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography>{DayNumberMapping[day]}</Typography>
                                <Typography>{findStoreAttributeValueByName(store.attributes, StoreOpenTimeAttrDayMapping[day], "displayValue")}</Typography>
                            </Stack>
                        )}
                        <Box>
                            {storepickallowed &&
                                <Typography fontSize={16} py={1}>&#x2714;&nbsp;{ClickAndCollectNLS.ClickAndCollect.t()}</Typography>
                            }
                        </Box>
                        <Linkable href={storeURL} sx={moreInfoBtnSx}>{ClickAndCollectNLS.MoreInfo.t()}</Linkable>
                    </Stack>
                </DialogContent>
            </Dialog>
        </Box>
    );
}